import * as React from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Typography,
  Card,
  CardContent,
  Box,
  Grid,
  Divider,
  Button,
  CircularProgress,
  AccordionDetails,
  AccordionSummary,
  Accordion,
  Tooltip,
  Input,
  Drawer,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  DialogActions,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import WorkIcon from "@mui/icons-material/Work";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import PeopleIcon from "@mui/icons-material/People";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import styles from "../../openPosition.module.css";
import apiCall from "../../../../../API/apiService";
import apiEndpoints from "../../../../../API/apiEndpoints";
import { toasty } from "../../../../../../Helper";
import { useDropzone } from "react-dropzone";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useState, useEffect } from "react";
import CSVUploadDrawer from "./CSVUploadDrawer";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import InfoIcon from "@mui/icons-material/Info";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AddIcon from "@mui/icons-material/Add";
import Menu from "@mui/material/Menu";
import EditIcon from "@mui/icons-material/Edit";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import BarChartIcon from "@mui/icons-material/BarChart";
import ReEvalButton from "../../../../../assets/svgComponent/Re-evalButton.svg"; // Import the SVG
import UploadResumeButton from "../../../../../assets/svgComponent/UploadResume.svg";
import AddApplicantButton from "../../../../../assets/svgComponent/AddApplicant.svg";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import UpdateButton from "../../../../../assets/svgComponent/UpdateButton.svg"; // Import the UpdateButton SVG
import AddSign from "../../../../../assets/svgComponent/AddSign.svg"; // Import the SVG
import RemoveSign from "../../../../../assets/svgComponent/RemoveSign.svg"; // Import the SVG
import DownloadSign from "../../../../../assets/svgComponent/DownloadSign.svg"; // Import the SVG
import UploadSign from "../../../../../assets/svgComponent/UploadSign.svg"; // Import the SVG
import CloseIcon from "@mui/icons-material/Close";
import { Collapse, Modal, Select as AntSelect } from 'antd'; // Import Collapse and Modal from Ant Design
import { ExpandMoreOutlined } from '@mui/icons-material'; // You can use an icon from MUI or Ant Design

// Add these constants at the top level
const DIFFICULTY_LEVELS = ["EASY", "MEDIUM", "HARD"];
const EVALUATION_TYPES = ["FRAMEWORK", "RUBRIC", "CRITERIA"];
const QUESTION_TYPES = [
  "CODING",
  "SUBJECTIVE",
  "SUBJECTIVE_PROBING",
  "CODE_DEBUG",
  "CODE_REACT",
];
const QUESTION_REQUIREMENTS = ["MANDATORY", "OPTIONAL"];

const { Panel } = Collapse; // Destructure Panel from Collapse

const Details = ({
  handleAddApplicant,
  getJobOpeningDetails,
  switchToApplicantsTab,
}) => {
  const [uploadInfo, setUploadInfo] = React.useState(null);
  const [isUploading, setIsUploading] = React.useState(false);
  const [selectedFiles, setSelectedFiles] = React.useState([]);
  const [selectedFilesInfo, setSelectedFilesInfo] = React.useState(null);
  const { id: job_opening_id } = useParams();

  const [data, setData] = React.useState(null); // State to hold fetched data
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
  const [sendEmails, setSendEmails] = useState(true);
  const [proctoringEnabled, setProctoringEnabled] = useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [updateQuestionsDialog, setUpdateQuestionsDialog] = useState({
    open: false,
    roundNo: null,
    questionsToAsk: "",
  });

  const [questionSelectionDialog, setQuestionSelectionDialog] = useState({
    open: false,
    selectedQuestions: [],
    roundNo: "",
    sourceRoundNo: "",
  });

  const [removeQuestionsDialog, setRemoveQuestionsDialog] = useState({
    open: false,
    roundNo: "",
    selectedQuestions: [],
    showQuestions: false,
  });

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false); // State for confirmation dialog

  const [actionMenuAnchor, setActionMenuAnchor] = useState(null);

  const [downloadMenuAnchor, setDownloadMenuAnchor] = useState(null);

  const [metricsDialogOpen, setMetricsDialogOpen] = useState(false);

  const [filteredApplicantsDialog, setFilteredApplicantsDialog] = useState({
    open: false,
    roundNo: null,
    status: null,
    applicants: [],
    loading: false,
  });

  const [isbulkUploadStatus, setBulkUploadStatus] = useState(false);
  const [isReEvalStatus, setReEvalStatus] = useState(false);
  const [statusModalVisible, setStatusModalVisible] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('');

  const [modelSelectionDialog, setModelSelectionDialog] = useState({
    open: false,
    selectedModel: "",
  });

  const [uploadPopupOpen, setUploadPopupOpen] = useState(false);
  const [selectedSource, setSelectedSource] = useState('');

  // Add this after other state declarations
  const RESUME_SOURCES = [
    { value: 'linkedin', label: 'LinkedIn' },
    { value: 'instahyre', label: 'InstaHyre' },
    { value: 'naukri', label: 'Naukri.com' },
    { value: 'indeed', label: 'Indeed' },
    { value: 'direct', label: 'Direct Upload' }
  ];

  const navigate = useNavigate();

  // Add these style objects
  const tableCellStyle = {
    width: "270px",
    minHeight: "54px",
    padding: "16px",
    gap: "5px",
    borderBottom: "0.5px solid rgba(0, 0, 0, 0.12)",
    verticalAlign: "top",
  };

  const cellContentStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    marginBottom: "12px",
  };

  const strongStyle = {
    minWidth: "109px",
    height: "18px",
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 500,
    lineHeight: "18px",
    letterSpacing: "-0.2px",
    textAlign: "left",
    color: "var(--Gray-900, rgba(117, 117, 130, 1))",
    marginBottom: "10px",
  };

  const spanStyle = {
    minWidth: "150  px",
    height: "22px",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "-0.2px",
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
    color: "var(--Gray-900, rgba(58, 58, 64, 1))",
    whiteSpace: "normal",
    wordBreak: "break-word",
    marginBottom: "12px",
  };

  // Add these custom styles
  const menuItemStyles = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "10px 16px",
    background: "var(--White, rgba(255, 255, 255, 1))",
    boxShadow: "0px 27px 11px 0px rgba(0, 0, 0, 0.01)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
    borderRadius: "8px",
  };

  const menuIconStyles = {
    width: 24,
    height: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  // Add new state for edit question dialog
  const [editQuestionDialog, setEditQuestionDialog] = useState({
    open: false,
    roundNo: "",
    questionData: null,
  });

  // Add new state for round number dialog
  const [roundNumberDialog, setRoundNumberDialog] = useState({
    open: false,
    questionData: null,
  });


  // Function to fetch data based on id
  const fetchData = async (id) => {
    try {
      const response = await apiCall(
        "get",
        `${apiEndpoints.JOB_OPENING}/${id}`
      ); // Assuming API call
      console.log("jndjndjndjndjndjndj", response);
      setData(response); // Save the fetched data to state
      setSendEmails(response.send_emails);
      
      // Initialize proctoring state from API data
      if (response.opening_rounds && Array.isArray(response.opening_rounds)) {
        const initialProctoringState = {};
        response.opening_rounds.forEach((round, index) => {
          const roundNo = index + 1;
          // Check if the round has proctoring_enabled field, default to false if not present
          initialProctoringState[roundNo] = round.proctoring_enabled || false;
        });
        setProctoringEnabled(initialProctoringState);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  React.useEffect(() => {
    const url = window.location.href;
    const pathSegments = url.split("/");
    const id = pathSegments[4];
    console.log("id:", id);
    if (id) {
      fetchData(id);
      getBulkUploadStatus();
      getRecalculateStatus();
    }
  }, []);

  useEffect(() => {
    // Initialize proctoring state when data changes
    if (data && data.opening_rounds && Array.isArray(data.opening_rounds)) {
      const initialProctoringState = {};
      data.opening_rounds.forEach((round, index) => {
        const roundNo = index + 1;
        // Check if the round has proctoring_enabled field, default to false if not present
        initialProctoringState[roundNo] = round.proctoring_enabled || false;
      });
      setProctoringEnabled(initialProctoringState);
    }
  }, [data]);

  const updateRoundDetails = async () => {
    try {
      const response = await apiCall(
        "get",
        `${apiEndpoints.JOB_OPENING}/${job_opening_id}`
      );
      setData(response);
      
      // Also update proctoring state when round details are updated
      if (response.opening_rounds && Array.isArray(response.opening_rounds)) {
        const updatedProctoringState = {};
        response.opening_rounds.forEach((round, index) => {
          const roundNo = index + 1;
          updatedProctoringState[roundNo] = round.proctoring_enabled || false;
        });
        setProctoringEnabled(updatedProctoringState);
      }
    } catch (error) {
      console.error("Error fetching updated round details:", error);
      toasty("Error updating round details", "error");
    }
  };

  const onDrop = React.useCallback((acceptedFiles) => {
    setSelectedFiles(acceptedFiles);
    const totalSize = acceptedFiles.reduce((acc, file) => acc + file.size, 0);
    setSelectedFilesInfo({
      count: acceptedFiles.length,
      size: (totalSize / (1024 * 1024)).toFixed(2), // Convert to MB and round to 2 decimal places
    });
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "application/pdf",
    multiple: true,
    disabled: isUploading,
  });

  const handleUploadResumes = async () => {
    const maxSize = 50 * 1024 * 1024; // 50MB in bytes
    const validFiles = [];
    const invalidFiles = [];
    let totalSize = 0;

    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];
      if (file.type === "application/pdf" && file.size <= maxSize) {
        validFiles.push(file);
        totalSize += file.size;
      } else {
        invalidFiles.push(file.name);
      }
    }

    if (invalidFiles.length > 0) {
      toasty(
        `The following files were not uploaded because they are either not PDFs or exceed 50MB: ${invalidFiles.join(
          ", "
        )}`,
        "error"
      );
    }

    if (validFiles.length > 0) {
      setIsUploading(true);
      try {
        const formData = new FormData();
        validFiles.forEach((file) => {
          formData.append("files", file);
        });
        formData.append("job_opening_id", job_opening_id);

        await uploadResume(formData);
        setTimeout(() => {
          getJobOpeningDetails();
        }, 1000);
        setUploadInfo({
          count: validFiles.length,
          size: (totalSize / (1024 * 1024)).toFixed(2),
        });
        toasty(
          `${validFiles.length} resume${validFiles.length > 1 ? "s" : ""
          } uploaded successfully`
        );
      } catch (error) {
        console.error("Error uploading resumes:", error);
        toasty("Error uploading resumes. Please try again.", "error");
      } finally {
        setIsUploading(false);
        setSelectedFiles([]);
      }
    } else {
      setUploadInfo(null);
    }
  };

  const uploadResume = async (formData) => {
    try {
      const data = await apiCall("post", apiEndpoints.UPLOAD_RESUME, formData);
    } catch (error) {
      console.error("Error uploading resume:", error);
      throw error;
    }
  };

  const clearSelectedFiles = () => {
    setSelectedFiles([]);
    setSelectedFilesInfo(null);
  };

  const getBaseURL = () => {
    const { protocol, host } = window.location;
    const domainParts = host.split(".");
    const mainDomain = domainParts.slice(-2).join(".");
    return `${protocol}//${mainDomain}`;
  };

  const baseURL = getBaseURL();

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleEmailToggle = async (event) => {
    const newValue = event.target.checked;
    setSendEmails(newValue);

    try {
      await apiCall("patch", apiEndpoints.UPDATE_SEND_EMAILS, {
        jobopening_id: job_opening_id,
        send_emails: newValue,
      });
      toasty(
        `Email notifications and interview scheduling ${newValue ? "enabled" : "disabled"
        } successfully`
      );
    } catch (error) {
      console.error("Error updating email preferences:", error);
      toasty("Error updating preferences", "error");
      setSendEmails(!newValue); // Revert the toggle if API call fails
    }
  };

  const handleProctoringToggle = async (roundIndex, currentStatus) => {
    try {
      const roundNo = roundIndex + 1; // Convert array index to round number
      await apiCall("patch", "/api/jobopening/update-proctoring-enabled", {
        jobopening_id: job_opening_id,
        round_no: roundNo,
        proctoring_enabled: !currentStatus
      });
      
      setProctoringEnabled(prev => ({
        ...prev,
        [roundNo]: !currentStatus
      }));
      
      toasty(`Proctoring ${!currentStatus ? 'enabled' : 'disabled'} successfully`);
    } catch (error) {
      console.error("Error updating proctoring status:", error);
      toasty("Error updating proctoring status", "error");
    }
  };

  const handleDownloadClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Add function to handle download submenu
  const handleDownloadMenuOpen = (event) => {
    event.stopPropagation();
    setDownloadMenuAnchor(event.currentTarget);
    handleActionMenuClose();
  };

  const handleDownloadMenuClose = () => {
    setDownloadMenuAnchor(null);
  };

  const downloadCSV = (type) => {
    const fileName = type === "qa" ? "save.csv" : "carrum.csv";
    const fileUrl = `/assets/CSV_files/${fileName}`;

    // Create a temporary anchor element
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    handleDownloadMenuClose();
  };

  const handleNavigateToQuestions = () => {
    // Store only the job opening ID initially
    localStorage.setItem(
      "questionSelectionContext",
      JSON.stringify({
        jobOpeningId: job_opening_id,
        returnPath: window.location.pathname,
      })
    );
    navigate("/question-list");
  };

  const handleUpdateQuestionsClick = () => {
    setUpdateQuestionsDialog({
      open: true,
      roundNo: "", // Empty string for user input
      questionsToAsk: "", // Empty string for user input
    });
  };

  const handleUpdateQuestions = async () => {
    try {
      await apiCall(
        "patch",
        `${apiEndpoints.JOB_OPENING}/${job_opening_id}/rounds/${updateQuestionsDialog.roundNo}/update-no-questions-ask/${updateQuestionsDialog.questionsToAsk}`
      );

      toasty("Questions to ask updated successfully");
      updateRoundDetails();
      setUpdateQuestionsDialog({
        open: false,
        roundNo: null,
        questionsToAsk: "",
      });
    } catch (error) {
      console.error("Error updating questions to ask:", error);
      toasty("Error updating questions to ask", "error");
    }
  };

  const handleConfirmQuestionSelection = async () => {
    const { roundNo, selectedQuestions } = questionSelectionDialog;

    // Validate roundNo
    if (!roundNo || isNaN(roundNo)) {
      toasty("Please enter a valid round number", "error");
      return;
    }

    try {
      await apiCall(
        "post",
        `${apiEndpoints.JOB_OPENING}/${job_opening_id}/rounds/${roundNo}/add-questions`,
        { questions: selectedQuestions }
      );
      toasty("Questions added successfully");
      updateRoundDetails();
      setQuestionSelectionDialog({
        open: false,
        selectedQuestions: [],
        roundNo: "",
      });
    } catch (error) {
      console.error("Error adding questions:", error);
      toasty("Error adding questions", "error");
    }
  };

  const handleRemoveQuestionsClick = () => {
    setRemoveQuestionsDialog({
      open: true,
      roundNo: "",
      selectedQuestions: [],
      showQuestions: false,
    });
  };

  const handleRemoveQuestions = async () => {
    try {
      await apiCall(
        "put",
        `${apiEndpoints.JOB_OPENING}/${job_opening_id}/rounds/${removeQuestionsDialog.roundNo}/remove-questions`,
        removeQuestionsDialog.selectedQuestions
      );

      toasty("Questions removed successfully");
      updateRoundDetails();
      setRemoveQuestionsDialog({
        open: false,
        roundNo: "",
        selectedQuestions: [],
        showQuestions: false,
      });
    } catch (error) {
      console.error("Error removing questions:", error);
      toasty("Error removing questions", "error");
    }
  };

  const handleRevealResume = () => {
    setOpenConfirmDialog(true); // Open confirmation dialog
  };

  const confirmRevealResume = async () => {
    setOpenConfirmDialog(false); // Close confirmation dialog
    try {
      apiCall(
        "post",
        `${apiEndpoints.JOB_OPENING}/${job_opening_id}/recalculate-scores`,
        null,
        { disableLoader: true }
      );
      // Handle the response as needed
      //console.log("Scores recalculated successfully:", response);
      toasty("Scores recalculated successfully");
      getRecalculateStatus();
    } catch (error) {
      console.error("Error recalculating scores:", error);
      toasty("Error recalculating scores. Please try again.", "error");
    }
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false); // Close confirmation dialog
  };

  const handleActionMenuOpen = (event) => {
    setActionMenuAnchor(event.currentTarget);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchor(null);
  };

  // Add responsive styles for the main container
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "16px",
    width: "100%", // Ensure it takes full width
    overflowX: "auto", // Allow horizontal scrolling if needed
    boxSizing: "border-box", // Include padding in width calculations
  };

  // Add media queries for better responsiveness
  const styles = {
    "@media (max-width: 600px)": {
      // Adjust styles for small screens
      container: {
        padding: "8px",
      },
      card: {
        margin: "0",
        padding: "16px",
      },
      // Adjust typography sizes
      typography: {
        fontSize: "14px",
      },
    },
    "@media (min-width: 601px) and (max-width: 1200px)": {
      // Adjust styles for medium screens
      card: {
        padding: "20px",
      },
    },
  };

  // Add new function to handle edit button click
  const handleEditQuestion = (questionData) => {
    setRoundNumberDialog({
      open: true,
      questionData: questionData,
    });
  };

  // Add function to handle round number confirmation
  const handleRoundNumberConfirm = () => {
    setEditQuestionDialog({
      open: true,
      roundNo: roundNumberDialog.roundNo,
      questionData: roundNumberDialog.questionData,
    });
    setRoundNumberDialog({ open: false, questionData: null });
  };

  // Add function to handle question update
  const handleUpdateQuestion = async () => {
    try {
      const payload = {
        jobopening_id: job_opening_id,
        round_no: parseInt(editQuestionDialog.roundNo),
        questions: [
          {
            ...editQuestionDialog.questionData,
            // Add any modified fields here
          },
        ],
      };

      await apiCall("put", apiEndpoints.UPDATE_QUESTIONS, payload);
      toasty("Question updated successfully");
      updateRoundDetails();
      setEditQuestionDialog({ open: false, roundNo: "", questionData: null });
    } catch (error) {
      console.error("Error updating question:", error);
      toasty("Error updating question", "error");
    }
  };

  const handleExport = async () => {
    try {
      await apiCall(
        "post",
        `${apiEndpoints.EXPORT_APPLICANTS}/${job_opening_id}`
      );
      toasty("Export initiated successfully");
    } catch (error) {
      console.error("Error exporting data:", error);
      toasty("Error exporting data", "error");
    }
  };

  // Add a function to switch to the Applicants tab with filters
  const handleStatusCardClick = (roundNumber, status) => {
    // Close the metrics dialog
    setMetricsDialogOpen(false);

    // Use the switchToApplicantsTab prop to change tabs and apply filters
    if (switchToApplicantsTab) {
      switchToApplicantsTab(roundNumber, status);
    }
  };

  const fetchFilteredApplicants = async (roundNumber, status) => {
    try {
      const response = await apiCall(
        "get",
        `/api/applicants/job_opening/${job_opening_id}?round_no=${roundNumber}&status=${status.toUpperCase()}`
      );

      setFilteredApplicantsDialog((prev) => ({
        ...prev,
        applicants: response.items || [], // Access the items array from the response
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching filtered applicants:", error);
      toasty("Error fetching applicants", "error");
      setFilteredApplicantsDialog((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const getBulkUploadStatus = async () => {
    try {
      const response = await apiCall(
        "get",
        `/api/upload-resumes-status/${job_opening_id}`
      );
      if (response?.status === "PROCESSING") {
        setBulkUploadStatus(true);
      }
    } catch (error) {
      console.error("Error fetching bulk upload status:", error);
      toasty("Error fetching bulk upload status", "error");
    }
  };

  const getRecalculateStatus = async () => {
    try {
      const response = await apiCall(
        "get",
        `/api/jobopenings/${job_opening_id}/recalculate-scores/status`
      );
      if (response?.status === "PROCESSING") {
        setReEvalStatus(true);
      }
    } catch (error) {
      console.error("Error fetching Re-Eval Resume upload status:", error);
      toasty("Error fetching Re-Eval Resume upload status", "error");
    }
  };

  const handleStatusUpdateClick = () => {
    setSelectedStatus(data?.jobopening_status || "OPEN");
    setStatusModalVisible(true);
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };

  const handleStatusSubmit = async () => {
    try {
      await apiCall(
        "put",
        `api/jobopening/status/${job_opening_id}?jobopening_status=${selectedStatus}`
      );
      toasty("Job opening status updated successfully");
      fetchData(job_opening_id); // Refresh data after update
      setStatusModalVisible(false);
    } catch (error) {
      console.error("Error updating job opening status:", error);
      toasty("Error updating job opening status", "error");
    }
  };

  const handleModelSelection = async () => {
    try {
      await apiCall(
        "put",
        `/api/jobopenings`,
        { llm_model: modelSelectionDialog.selectedModel, id: job_opening_id }
      );
      toasty("Model updated successfully");
      setModelSelectionDialog({ open: false, selectedModel: "" });
    } catch (error) {
      console.error("Error updating model:", error);
      toasty("Error updating model", "error");
    }
  };

  // Add this new function
  const handleResumeUpload = async (files, source) => {
    setIsUploading(true);
    try {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append("files", file);
      });
      formData.append("job_opening_id", job_opening_id);
      formData.append("resume_source", source);

      await uploadResume(formData);
      setTimeout(() => {
        getJobOpeningDetails();
      }, 1000);
      toasty(`${files.length} resume${files.length > 1 ? "s" : ""} uploaded successfully`);
      setUploadPopupOpen(false);
      setSelectedSource('');
    } catch (error) {
      console.error("Error uploading resumes:", error);
      toasty("Error uploading resumes. Please try again.", "error");
    } finally {
      setIsUploading(false);
      setSelectedFiles([]);
    }
  };

  return (
    <div className={styles.container}>
        <div
          style={{
            display: "flex",
            marginLeft:20,
            width:'96%',
            justifyContent:'flex-end',
          }}
        >
          <Button
            onClick={() => setModelSelectionDialog({ open: true, selectedModel: "" })}
            sx={{
              cursor: "pointer",
              width: "140px",
              height: "27px",
              padding: "2px 8px",
              gap: "8px",
              borderRadius: "6px",
              marginTop: "14px",
              backgroundColor: "var(--Blue-50, rgba(239, 246, 255, 1))",
              color: "var(--Blue-600, rgba(37, 99, 235, 1))",
              fontSize:12,
              textTransform:'capitalize',
              fontWeight:'500',
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "&:hover": {
                backgroundColor:
                  "var(--Blue-100, rgba(219, 234, 254, 1))",
              },
            }}
          >
            <FileDownloadIcon sx={{ mr: 1, width:14, height:18 }} />
            Model Selection
          </Button>
          <Button
            onClick={handleExport}
            sx={{
              cursor: "pointer",
              width: "120px",
              height: "27px",
              padding: "2px 8px",
              gap: "6px",
              borderRadius: "6px",
              marginTop: "14px",
              backgroundColor: "var(--Blue-50, rgba(239, 246, 255, 1))",
              color: "var(--Blue-600, rgba(37, 99, 235, 1))",
              fontSize:12,
              textTransform:'capitalize',
              fontWeight:'500',
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "&:hover": {
                backgroundColor:
                  "var(--Blue-100, rgba(219, 234, 254, 1))",
              },
            }}
          >
            <FileDownloadIcon sx={{ mr: 1, width:14, height:18 }} />
            Export
          </Button>
          <Button
            onClick={handleStatusUpdateClick}
            sx={{
              cursor: "pointer",
              width: "150px",
              height: "29px",
              padding: "4px 12px",
              gap: "6px",
              borderRadius: "6px",
              marginTop: "14px",
              marginLeft: "10px",
              backgroundColor: "var(--Blue-50, rgba(239, 246, 255, 1))",
              color: "var(--Blue-600, rgba(37, 99, 235, 1))",
              fontSize: 12,
              textTransform: 'capitalize',
              fontWeight: '500',
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "&:hover": {
                backgroundColor:
                  "var(--Blue-100, rgba(219, 234, 254, 1))",
              },
            }}
          >
            <EditIcon sx={{ mr: 1, width: 14, height: 18 }} />
            Update Status
          </Button>
          <img
            src={ReEvalButton}
            alt="Re-Eval Resume"
            style={{
              cursor: isReEvalStatus ? "not-allowed" : "pointer",
              width: "120px",
              height: "48px",
              padding: "2px 8px",
              gap: "6px",
              borderRadius: "6px",
              marginTop: "5px",
            }}
            onClick={isReEvalStatus ? null : handleRevealResume}
          />
          <Box
            component="div"
            sx={{
              width: "120px",
              height: "58px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={UploadResumeButton}
              alt="Upload Resume"
              style={{
                cursor: isUploading || isbulkUploadStatus ? "not-allowed" : "pointer",
                width: "100%",
                height: "100px",
                objectFit: "contain",
                opacity: isUploading ? 0.7 : 1,
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (!isUploading && !isbulkUploadStatus) {
                  setUploadPopupOpen(true);
                }
              }}
            />
          </Box>

          <img
            src={AddApplicantButton}
            alt="Add Applicant"
            onClick={handleAddApplicant}
            disabled={isUploading}
            style={{
              cursor: "pointer",
              width: "117px",
              height: "28px",
              padding: "2px 8px",
              gap: "6px",
              borderRadius: "6px",
              marginTop: "11px",
            }}
          />
        </div>

      <Card
        className={styles.card}
        sx={{
          mb: 3,
          backgroundColor: "#ffffff",
          borderRadius: 3,
          boxShadow: 3,
          // padding: '3px 0',
          margin: '0 20px',
          width: "95%", // Make card full width
          maxWidth: "1300px", // Set a max width
          height: "74vh",
          overflow: "scroll", // Prevent overflow
        }}
      >
        <CardContent>
          <Box
            sx={{
              width: "95%", // Make it responsive
              maxWidth: "1300px", // Set a max width
              height: "auto", // Allow height to adjust
              position: "relative",
              borderRadius: "12px",
              backgroundColor: "var(--White, rgba(255, 255, 255, 1))",
              boxShadow: `0px 1px 2px 1px rgba(0, 0, 0, 0.06),
                          0px 1px 3px 1px rgba(0, 0, 0, 0.1),
                          0px 0px 0px 1px rgba(17, 24, 39, 0.1)`,
              padding: "24px",
              boxSizing: "border-box", // Include padding in width calculations
            }}
          >
            <Typography
              variant="h5"
              sx={{
                color: "var(--Dark-Blue-700, rgba(29, 88, 216, 1))",
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "24px",
                letterSpacing: "-0.3px",
                textAlign: "left",
                textUnderlinePosition: "from-font",
                textDecorationSkipInk: "none",
                width: "253px",
                height: "24px",
                mb: 2,
              }}
            >
              {data?.role_name}
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                marginRight: "10px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Department:</strong>
                  <span style={spanStyle}>{data?.department_name}</span>
                </div>

                <Divider
                  style={{
                    height: "30px",
                    margin: "0 24px",
                    borderLeft: "1px solid #ccc",
                  }}
                />

                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Sub-Department:</strong>
                  <span style={spanStyle}>{data?.subdepartment_name}</span>
                </div>
              </Box>

                <Box
                  sx={{
                    mt: -1,
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    height: "1px",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        checked={sendEmails}
                        onChange={handleEmailToggle}
                        color="primary"
                        size="small"
                      />
                    }
                    label={
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                          sx={{
                            mr: 1,
                            fontFamily: "Inter",
                            fontHeight: "14px",
                            color: "var(--Gray-900, rgba(58, 58, 64, 1))",
                            fontSize:14
                          }}
                        >
                          Email Notifications
                        </Typography>
                        <Tooltip title="When enabled, emails will automatically be sent to the applicant.">
                          <InfoIcon
                            fontSize="small"
                            sx={{
                              color: "var(--Gray-500, rgba(58, 58, 64, 1))",
                            }}
                            style={{width:16, height:16}}
                          />
                        </Tooltip>
                      </Box>
                    }
                  />
                </Box>
            </Box>

            <Divider sx={{ my: 2 }} />

            <Grid
              container
              spacing={3}
              sx={{ width: "100%", overflowX: "auto", flexWrap: "wrap" }}
            >
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Employment Type</strong>
                  <span style={spanStyle}>
                    {data?.employment_type || "N/A"}
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Work Type</strong>
                  <span style={spanStyle}>
                    {data?.work_arrangement || "N/A"}
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Level</strong>
                  <span style={spanStyle}>{data?.level || "N/A"}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Salary</strong>
                  <span style={spanStyle}>
                    {data?.salary_min} - {data?.salary_max}
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Number of Positions</strong>
                  <span style={spanStyle}>
                    {data?.no_open_positions || "N/A"}
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>City</strong>
                  <span style={spanStyle}>{data?.city_id || "N/A"}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Status</strong>
                  <span style={{
                    ...spanStyle,
                    color: data?.jobopening_status === "OPEN" ? "green" : 
                           data?.jobopening_status === "CLOSED" ? "red" :
                           data?.jobopening_status === "FILLED" ? "blue" : "orange"
                  }}>
                    {data?.jobopening_status || "OPEN"}
                  </span>
                </div>
              </Grid>
            </Grid>
          </Box>

          {/* Round details */}
          {data?.opening_rounds?.length > 0 && (
            <Box mt={5}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={4}
              >
                <Typography
                  variant="h6"
                  sx={{
                    width: "auto",
                    height: "24px",
                    gap: "6px",
                    fontFamily: "Inter",
                    fontSize: { xs: "14px", sm: "16px" }, // Responsive font size
                    fontWeight: 500,
                    lineHeight: "24px",
                    letterSpacing: "-0.3px",
                    textAlign: "left",
                    textUnderlinePosition: "from-font",
                    textDecorationSkipInk: "none",
                    color: "var(--Gray-900, rgba(58, 58, 64, 1))",
                  }}
                >
                  Round Details:{" "}
                  <span style={{ display: "inline" }}>
                    ({data.opening_rounds.length}/{data.total_rounds})
                  </span>
                </Typography>
              </Box>

              {data.opening_rounds.map((round, roundIndex) => (
                <Collapse
                  key={roundIndex}
                  accordion
                  expandIconPosition="right"
                  style={{
                    marginBottom: '16px',
                    width: '95%',
                    backgroundColor: '#f7f9fc',
                    borderRadius: '8px',
                    boxShadow: '0px 1px 2px 1px rgba(0, 0, 0, 0.06)',
                  }}
                >
                  <Panel
                    header={
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: '500',
                            fontFamily: 'Inter',
                          }}
                        >
                          {round.round_name} (Round {roundIndex + 1}) - {round.type}
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={proctoringEnabled[roundIndex + 1] || false}
                                  onChange={() => handleProctoringToggle(roundIndex, proctoringEnabled[roundIndex + 1] || false)}
                                  color="primary"
                                  size="small"
                                />
                              }
                              label={
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                  <Typography
                                    sx={{
                                      mr: 1,
                                      fontFamily: "Inter",
                                      fontHeight: "14px",
                                      color: "var(--Gray-900, rgba(58, 58, 64, 1))",
                                      fontSize: 14
                                    }}
                                  >
                                    Proctoring
                                  </Typography>
                                  <Tooltip title="When enabled, proctoring will be active for this round.">
                                    <InfoIcon
                                      fontSize="small"
                                      sx={{
                                        color: "var(--Gray-500, rgba(58, 58, 64, 1))",
                                      }}
                                      style={{width:16, height:16}}
                                    />
                                  </Tooltip>
                                </Box>
                              }
                            />
                            <Typography
                              variant="subtitle1"
                              sx={{
                                color: '#666',
                                fontFamily: 'Inter',
                                marginRight: '20px',
                              }}
                            >
                              Questions to be Asked: {round.no_questions_ask} | Total Questions: {round.total_questions}
                            </Typography>
                          </Box>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleActionMenuOpen(e);
                            }}
                          >
                            <img
                              src={UpdateButton}
                              alt="Update"
                              style={{
                                width: '60px',
                                height: '25px',
                                padding: '2px 6px',
                                borderRadius: '6px',
                              }}
                            />
                          </IconButton>
                        </Box>
                      </Box>
                    }
                    key={roundIndex}
                  >
                    {round.question_bank.map((question, qIndex) => (
                      <Box
                        key={qIndex}
                        sx={{
                          mb: 2,
                          pb: 1,
                          borderBottom: '1px solid #eee',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                        }}
                      >
                        <Box>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: '500',
                              mb: 1,
                              fontFamily: 'Inter',
                              color: 'var(--Gray-900, rgba(58, 58, 64, 1))',
                            }}
                          >
                            Q{qIndex + 1}: {question.question}
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: '500',
                              mb: 1,
                              fontFamily: 'Inter',
                              color: 'var(--Gray-900, rgba(58, 58, 64, 1))',
                            }}
                          >
                            Type: {question.type || 'N/A'}
                          </Typography>

                          {/* Answer Section */}
                          {question.evaluation_type === 'CRITERIA' && (
                            <Box sx={{ pl: 2, mb: 2 }}>
                              <Typography
                                variant="body2"
                                sx={{
                                  color: '#666',
                                  fontFamily: 'Inter',
                                  color: 'var(--Gray-900, rgba(58, 58, 64, 1))',
                                }}
                              >
                                A: {question.evaluation_criteria}
                              </Typography>
                            </Box>
                          )}

                          {/* Rubric Section */}
                          {question.evaluation_type === 'RUBRIC' &&
                            question.evaluation_rubric &&
                            question.evaluation_rubric.length > 0 && (
                              <Box sx={{ pl: 2 }}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 'bold',
                                    mb: 1,
                                    fontFamily: 'Inter',
                                    color: 'var(--Gray-900, rgba(58, 58, 64, 1))',
                                  }}
                                >
                                  Evaluation Rubric:
                                </Typography>
                                {question.evaluation_rubric.map((rubric, rIndex) => (
                                  <Typography
                                    key={rIndex}
                                    variant="body2"
                                    sx={{
                                      mb: 1,
                                      fontFamily: 'Inter',
                                      color: 'var(--Gray-900, rgba(58, 58, 64, 1))',
                                    }}
                                  >
                                    • {rubric}
                                  </Typography>
                                ))}
                              </Box>
                            )}
                        </Box>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditQuestion(question);
                          }}
                          sx={{
                            backgroundColor: 'var(--Blue-50, rgba(239, 246, 255, 1))',
                            borderRadius: '6px',
                            padding: '8px',
                            '&:hover': {
                              backgroundColor: 'var(--Blue-100, rgba(219, 234, 254, 1))',
                            },
                          }}
                        >
                          <EditIcon
                            sx={{
                              fontSize: 20,
                              color: 'var(--Blue-600, rgba(37, 99, 235, 1))',
                            }}
                          />
                        </IconButton>
                      </Box>
                    ))}
                  </Panel>
                </Collapse>
              ))}
            </Box>
          )}
        </CardContent>
      </Card>

      {/* CSV Upload Drawer */}
      <Drawer anchor="right" open={isDrawerOpen} onClose={handleCloseDrawer}>
        <CSVUploadDrawer
          onClose={handleCloseDrawer}
          job_opening_id={job_opening_id} // Ensure this is the correct ID
          data={data}
          updateRoundDetails={updateRoundDetails}
        />
      </Drawer>

      <Dialog
        open={updateQuestionsDialog.open}
        onClose={() =>
          setUpdateQuestionsDialog({
            open: false,
            roundNo: "",
            questionsToAsk: "",
          })
        }
      >
        <DialogTitle>Update Questions to Ask</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enter the round number and the number of questions to be asked.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Round Number"
            type="number"
            fullWidth
            value={updateQuestionsDialog.roundNo}
            onChange={(e) =>
              setUpdateQuestionsDialog({
                ...updateQuestionsDialog,
                roundNo: e.target.value,
              })
            }
          />
          <TextField
            margin="dense"
            label="Number of Questions"
            type="number"
            fullWidth
            value={updateQuestionsDialog.questionsToAsk}
            onChange={(e) =>
              setUpdateQuestionsDialog({
                ...updateQuestionsDialog,
                questionsToAsk: e.target.value,
              })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setUpdateQuestionsDialog({
                open: false,
                roundNo: "",
                questionsToAsk: "",
              })
            }
          >
            Cancel
          </Button>
          <Button onClick={handleUpdateQuestions} variant="contained">
            Update
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={questionSelectionDialog.open}
        onClose={() =>
          setQuestionSelectionDialog({
            open: false,
            selectedQuestions: [],
            roundNo: "",
            sourceRoundNo: "",
          })
        }
      >
        <DialogTitle>Copy Questions to Another Round</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Select the target round number to copy the questions to:
          </DialogContentText>
          <TextField
            margin="dense"
            label="Target Round Number"
            type="number"
            fullWidth
            value={questionSelectionDialog.roundNo}
            onChange={(e) =>
              setQuestionSelectionDialog((prev) => ({
                ...prev,
                roundNo: e.target.value,
              }))
            }
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setQuestionSelectionDialog({
                open: false,
                selectedQuestions: [],
                roundNo: "",
                sourceRoundNo: "",
              })
            }
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmQuestionSelection}
            variant="contained"
            disabled={!questionSelectionDialog.roundNo}
          >
            Copy Questions
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={removeQuestionsDialog.open}
        onClose={() =>
          setRemoveQuestionsDialog({
            open: false,
            roundNo: "",
            selectedQuestions: [],
            showQuestions: false,
          })
        }
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Remove Questions</DialogTitle>
        <DialogContent>
          {!removeQuestionsDialog.showQuestions ? (
            <TextField
              autoFocus
              margin="dense"
              label="Round Number"
              type="number"
              fullWidth
              value={removeQuestionsDialog.roundNo}
              onChange={(e) => {
                const roundNo = e.target.value;
                setRemoveQuestionsDialog((prev) => ({
                  ...prev,
                  roundNo,
                  showQuestions: roundNo && data?.opening_rounds[roundNo - 1],
                }));
              }}
            />
          ) : (
            <Box sx={{ mt: 2 }}>
              {data?.opening_rounds[
                removeQuestionsDialog.roundNo - 1
              ]?.question_bank.map((question, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#f5f5f5" },
                  }}
                  onClick={() => {
                    const isSelected =
                      removeQuestionsDialog.selectedQuestions.includes(
                        question.id
                      );
                    setRemoveQuestionsDialog((prev) => ({
                      ...prev,
                      selectedQuestions: isSelected
                        ? prev.selectedQuestions.filter(
                          (id) => id !== question.id
                        )
                        : [...prev.selectedQuestions, question.id],
                    }));
                  }}
                >
                  {removeQuestionsDialog.selectedQuestions.includes(
                    question.id
                  ) ? (
                    <RadioButtonCheckedIcon sx={{ mr: 1 }} color="primary" />
                  ) : (
                    <RadioButtonUncheckedIcon sx={{ mr: 1 }} />
                  )}
                  <Typography>{question.question}</Typography>
                </Box>
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setRemoveQuestionsDialog({
                open: false,
                roundNo: "",
                selectedQuestions: [],
                showQuestions: false,
              })
            }
          >
            Cancel
          </Button>
          <Button
            onClick={handleRemoveQuestions}
            variant="contained"
            color="error"
            disabled={removeQuestionsDialog.selectedQuestions.length === 0}
          >
            Remove Selected
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Dialog */}
      <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog}>
        <DialogTitle>Confirm Re-evaluation</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to re-evaluate the resume score?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmRevealResume} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Download Menu */}
      <Menu
        anchorEl={downloadMenuAnchor}
        open={Boolean(downloadMenuAnchor)}
        onClose={handleDownloadMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          elevation: 3,
          sx: {
            mt: 1,
            borderRadius: "20px",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            minWidth: "200px",
            padding: "8px",
            border: "1px solid rgba(0, 0, 0, 0.08)",
          },
        }}
      >
        <MenuItem onClick={() => downloadCSV("qa")} sx={menuItemStyles}>
          <Typography>Questions & Answers</Typography>
        </MenuItem>
        <MenuItem onClick={() => downloadCSV("qae")} sx={menuItemStyles}>
          <Typography>Questions, Answers & Evaluations</Typography>
        </MenuItem>
      </Menu>

      {/* Add Menu component for action menu */}
      <Menu
        anchorEl={actionMenuAnchor}
        open={Boolean(actionMenuAnchor)}
        onClose={handleActionMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          elevation: 3,
          sx: {
            mt: 1,
            borderRadius: "8px",
            minWidth: "200px",
            padding: "8px",
          },
        }}
      >
        <MenuItem
          onClick={() => {
            handleOpenDrawer();
            handleActionMenuClose();
          }}
          sx={menuItemStyles}
        >
          <Box sx={menuIconStyles}>
            <img
              src={UploadSign}
              alt="Upload CSV"
              style={{ width: "20px", height: "20px" }}
            />
          </Box>
          <Typography>Upload CSV</Typography>
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleNavigateToQuestions();
            handleActionMenuClose();
          }}
          sx={menuItemStyles}
        >
          <Box sx={menuIconStyles}>
            <img
              src={AddSign}
              alt="Add Questions"
              style={{ width: "20px", height: "20px" }}
            />
          </Box>
          <Typography>Add Questions</Typography>
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleRemoveQuestionsClick();
            handleActionMenuClose();
          }}
          sx={{
            ...menuItemStyles,
            "&:hover": {
              backgroundColor: "rgba(255, 77, 79, 0.15)",
              borderRadius: "10px",
            },
            color: " var(--Gray-700, rgba(78, 78, 86, 1))",
            color: "#FF4D4F",
            backgroundColor: "rgba(255, 77, 79, 0.1)",
          }}
        >
          <Box sx={menuIconStyles}>
            <img
              src={RemoveSign}
              alt="Remove Questions"
              style={{ width: "20px", height: "20px" }}
            />
          </Box>
          <Typography sx={{ color: "#FF4D4F" }}>Remove Questions</Typography>
        </MenuItem>

        <MenuItem onClick={handleDownloadMenuOpen} sx={menuItemStyles}>
          <Box sx={menuIconStyles}>
            <img
              src={DownloadSign}
              alt="Download Template"
              style={{ width: "20px", height: "20px" }}
            />
          </Box>
          <Typography>Download Template</Typography>
        </MenuItem>
      </Menu>

      {/* Add Round Number Dialog */}
      <Dialog
        open={roundNumberDialog.open}
        onClose={() =>
          setRoundNumberDialog({ open: false, questionData: null })
        }
      >
        <DialogTitle>Enter Round Number</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Round Number"
            type="number"
            fullWidth
            value={roundNumberDialog.roundNo}
            onChange={(e) =>
              setRoundNumberDialog((prev) => ({
                ...prev,
                roundNo: e.target.value,
              }))
            }
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setRoundNumberDialog({ open: false, questionData: null })
            }
          >
            Cancel
          </Button>
          <Button
            onClick={handleRoundNumberConfirm}
            variant="contained"
            disabled={!roundNumberDialog.roundNo}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Edit Question Dialog */}
      <Dialog
        open={editQuestionDialog.open}
        onClose={() =>
          setEditQuestionDialog({
            open: false,
            roundNo: "",
            questionData: null,
          })
        }
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Edit Question</DialogTitle>
        <DialogContent>
          {editQuestionDialog.questionData && (
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={3}>
                {/* First Column */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="Question"
                    value={editQuestionDialog.questionData.question || ""}
                    onChange={(e) =>
                      setEditQuestionDialog((prev) => ({
                        ...prev,
                        questionData: {
                          ...prev.questionData,
                          question: e.target.value,
                        },
                      }))
                    }
                    sx={{ mb: 2 }}
                  />

                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Difficulty</InputLabel>
                    <Select
                      label="Difficulty"
                      value={editQuestionDialog.questionData.difficulty || ""}
                      onChange={(e) =>
                        setEditQuestionDialog((prev) => ({
                          ...prev,
                          questionData: {
                            ...prev.questionData,
                            difficulty: e.target.value,
                          },
                        }))
                      }
                    >
                      {DIFFICULTY_LEVELS.map((level) => (
                        <MenuItem key={level} value={level}>
                          {level}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <TextField
                    fullWidth
                    label="Skills"
                    value={
                      editQuestionDialog.questionData.skills?.join(", ") || ""
                    }
                    onChange={(e) =>
                      setEditQuestionDialog((prev) => ({
                        ...prev,
                        questionData: {
                          ...prev.questionData,
                          skills: e.target.value
                            .split(",")
                            .map((skill) => skill.trim()),
                        },
                      }))
                    }
                    helperText="Enter skills separated by commas"
                    sx={{ mb: 2 }}
                  />

                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Question Type</InputLabel>
                    <Select
                      label="Question Type"
                      value={editQuestionDialog.questionData.type || ""}
                      onChange={(e) =>
                        setEditQuestionDialog((prev) => ({
                          ...prev,
                          questionData: {
                            ...prev.questionData,
                            type: e.target.value,
                          },
                        }))
                      }
                    >
                      {QUESTION_TYPES.map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Question Requirement</InputLabel>
                    <Select
                      label="Question Requirement"
                      value={
                        editQuestionDialog.questionData.question_requirement ||
                        ""
                      }
                      onChange={(e) =>
                        setEditQuestionDialog((prev) => ({
                          ...prev,
                          questionData: {
                            ...prev.questionData,
                            question_requirement: e.target.value,
                          },
                        }))
                      }
                    >
                      {QUESTION_REQUIREMENTS.map((req) => (
                        <MenuItem key={req} value={req}>
                          {req}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Second Column */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Evaluation Type"
                    value={
                      editQuestionDialog.questionData.evaluation_type || ""
                    }
                    disabled
                    sx={{ mb: 2 }}
                  />

                  {/* Show probe level and probe objective only for SUBJECTIVE and SUBJECTIVE_PROBING types */}
                  {(editQuestionDialog.questionData.type === "SUBJECTIVE" ||
                    editQuestionDialog.questionData.type ===
                    "SUBJECTIVE_PROBING") && (
                      <>
                        <TextField
                          fullWidth
                          type="number"
                          label="Probe Level"
                          value={
                            editQuestionDialog.questionData.probe_level || ""
                          }
                          onChange={(e) =>
                            setEditQuestionDialog((prev) => ({
                              ...prev,
                              questionData: {
                                ...prev.questionData,
                                probe_level: e.target.value,
                              },
                            }))
                          }
                          sx={{ mb: 2 }}
                        />

                        <TextField
                          fullWidth
                          multiline
                          rows={3}
                          label="Probe Objective"
                          value={
                            editQuestionDialog.questionData.probe_objective || ""
                          }
                          onChange={(e) =>
                            setEditQuestionDialog((prev) => ({
                              ...prev,
                              questionData: {
                                ...prev.questionData,
                                probe_objective: e.target.value,
                              },
                            }))
                          }
                          sx={{ mb: 2 }}
                        />
                      </>
                    )}

                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Focus Objective"
                    value={
                      editQuestionDialog.questionData.focus_objective || ""
                    }
                    onChange={(e) =>
                      setEditQuestionDialog((prev) => ({
                        ...prev,
                        questionData: {
                          ...prev.questionData,
                          focus_objective: e.target.value,
                        },
                      }))
                    }
                    sx={{ mb: 2 }}
                  />
                </Grid>

                {/* Full Width Fields */}
                <Grid item xs={12}>
                  {/* Show Question Remarks and Boilerplate Code only for coding-related questions */}
                  {(editQuestionDialog.questionData.type === "CODING" ||
                    editQuestionDialog.questionData.type === "CODE_DEBUG" ||
                    editQuestionDialog.questionData.type === "CODE_REACT") && (
                      <>
                        <TextField
                          fullWidth
                          multiline
                          rows={4}
                          label="Question Remarks"
                          value={
                            editQuestionDialog.questionData.question_remarks || ""
                          }
                          onChange={(e) =>
                            setEditQuestionDialog((prev) => ({
                              ...prev,
                              questionData: {
                                ...prev.questionData,
                                question_remarks: e.target.value,
                              },
                            }))
                          }
                          sx={{ mb: 2 }}
                        />

                        {/* Boilerplate Code */}
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="h6" sx={{ mb: 1 }}>
                            Boilerplate Code
                          </Typography>
                          {Object.entries(
                            editQuestionDialog.questionData.boilerplate_code || {}
                          ).map(([language, code]) => (
                            <TextField
                              key={language}
                              fullWidth
                              multiline
                              rows={4}
                              label={`${language} Code`}
                              value={code}
                              onChange={(e) =>
                                setEditQuestionDialog((prev) => ({
                                  ...prev,
                                  questionData: {
                                    ...prev.questionData,
                                    boilerplate_code: {
                                      ...prev.questionData.boilerplate_code,
                                      [language]: e.target.value,
                                    },
                                  },
                                }))
                              }
                              sx={{ mb: 2 }}
                            />
                          ))}
                        </Box>
                      </>
                    )}

                  {/* Evaluation Criteria - Show when type is CRITERIA */}
                  {editQuestionDialog.questionData.evaluation_type ===
                    "CRITERIA" && (
                      <TextField
                        fullWidth
                        multiline
                        rows={4}
                        label="Evaluation Criteria"
                        value={
                          editQuestionDialog.questionData.evaluation_criteria ||
                          ""
                        }
                        onChange={(e) =>
                          setEditQuestionDialog((prev) => ({
                            ...prev,
                            questionData: {
                              ...prev.questionData,
                              evaluation_criteria: e.target.value,
                            },
                          }))
                        }
                        sx={{ mb: 2 }}
                      />
                    )}

                  {/* Evaluation Rubric - Show when type is RUBRIC */}
                  {editQuestionDialog.questionData.evaluation_type ===
                    "RUBRIC" && (
                      <Box sx={{ mb: 2 }}>
                        <Typography variant="h6" sx={{ mb: 1 }}>
                          Evaluation Rubric
                        </Typography>
                        {editQuestionDialog.questionData.evaluation_rubric?.map(
                          (rubric, index) => (
                            <TextField
                              key={index}
                              fullWidth
                              multiline
                              rows={2}
                              label={`Level ${5 - index}`}
                              value={rubric}
                              onChange={(e) => {
                                const newRubric = [
                                  ...(editQuestionDialog.questionData
                                    .evaluation_rubric || []),
                                ];
                                newRubric[index] = e.target.value;
                                setEditQuestionDialog((prev) => ({
                                  ...prev,
                                  questionData: {
                                    ...prev.questionData,
                                    evaluation_rubric: newRubric,
                                  },
                                }));
                              }}
                              sx={{ mb: 1 }}
                            />
                          )
                        )}
                      </Box>
                    )}

                  {/* Evaluation Framework - Show when type is FRAMEWORK */}
                  {editQuestionDialog.questionData.evaluation_type ===
                    "FRAMEWORK" && (
                      <Box sx={{ mb: 2 }}>
                        <Typography variant="h6" sx={{ mb: 1 }}>
                          Evaluation Framework
                        </Typography>
                        {Array.isArray(
                          editQuestionDialog.questionData.evaluation_framework
                        ) ? (
                          editQuestionDialog.questionData.evaluation_framework.map(
                            (framework, index) => (
                              <TextField
                                key={index}
                                fullWidth
                                multiline
                                rows={3}
                                label={`Framework Level ${index + 1}`}
                                value={
                                  typeof framework === "object"
                                    ? JSON.stringify(framework, null, 2)
                                    : framework
                                }
                                onChange={(e) => {
                                  const newFramework = [
                                    ...editQuestionDialog.questionData
                                      .evaluation_framework,
                                  ];
                                  try {
                                    newFramework[index] = JSON.parse(
                                      e.target.value
                                    );
                                  } catch {
                                    newFramework[index] = e.target.value;
                                  }
                                  setEditQuestionDialog((prev) => ({
                                    ...prev,
                                    questionData: {
                                      ...prev.questionData,
                                      evaluation_framework: newFramework,
                                    },
                                  }));
                                }}
                                sx={{ mb: 2 }}
                              />
                            )
                          )
                        ) : (
                          <TextField
                            fullWidth
                            multiline
                            rows={4}
                            label="Evaluation Framework"
                            value={
                              typeof editQuestionDialog.questionData
                                .evaluation_framework === "object"
                                ? JSON.stringify(
                                  editQuestionDialog.questionData
                                    .evaluation_framework,
                                  null,
                                  2
                                )
                                : editQuestionDialog.questionData
                                  .evaluation_framework || ""
                            }
                            onChange={(e) =>
                              setEditQuestionDialog((prev) => ({
                                ...prev,
                                questionData: {
                                  ...prev.questionData,
                                  evaluation_framework: e.target.value,
                                },
                              }))
                            }
                            sx={{ mb: 2 }}
                          />
                        )}
                      </Box>
                    )}
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setEditQuestionDialog({
                open: false,
                roundNo: "",
                questionData: null,
              })
            }
          >
            Cancel
          </Button>
          <Button onClick={handleUpdateQuestion} variant="contained">
            Update
          </Button>
        </DialogActions>
      </Dialog>

      {/* Status Update Modal */}
      <Modal
        title="Update Job Opening Status"
        open={statusModalVisible}
        onCancel={() => setStatusModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setStatusModalVisible(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleStatusSubmit}
            style={{
              backgroundColor: "var(--Blue-600, rgba(37, 99, 235, 1))",
              color: "white",
            }}
          >
            Submit
          </Button>,
        ]}
      >
        <div style={{ marginTop: "20px" }}>
          <Typography style={{ marginBottom: "10px" }}>Select Status:</Typography>
          <AntSelect
            value={selectedStatus}
            onChange={handleStatusChange}
            style={{ width: "100%", boxShadow: '0 2px 8px rgba(0, 0.15, 0.15, 0.15)', borderRadius: '6px', height: '50px' }}
            dropdownStyle={{
              border: '1px solid #d9d9d9',
              borderRadius: '4px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15, 0.15)'
            }}
            options={[
              { value: "OPEN", label: "OPEN" },
              { value: "CLOSED", label: "CLOSED" },
              { value: "FILLED", label: "FILLED" },
              { value: "HOLD", label: "HOLD" },
            ]}
          />
        </div>
      </Modal>

      {/* Model Selection Dialog */}
      <Modal
        title="Select Resume Evaluation Model"
        open={modelSelectionDialog.open}
        onCancel={() => setModelSelectionDialog({ open: false, selectedModel: "" })}
        footer={[
          <Button key="cancel" onClick={() => setModelSelectionDialog({ open: false, selectedModel: "" })}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleModelSelection}
            disabled={!modelSelectionDialog.selectedModel}
            style={{
              backgroundColor: "var(--Blue-600, rgba(37, 99, 235, 1))",
              color: "white",
            }}
          >
            Update
          </Button>,
        ]}
      >
        <div style={{ marginTop: "20px" }}>
          <Typography style={{ marginBottom: "10px" }}>Select Model:</Typography>
          <AntSelect
            showSearch
            value={modelSelectionDialog.selectedModel}
            onChange={(value) => setModelSelectionDialog(prev => ({ ...prev, selectedModel: value }))}
            style={{ width: "100%", boxShadow: '0 2px 8px rgba(0, 0.15, 0.15, 0.15)', borderRadius: '6px', height: '50px' }}
            dropdownStyle={{
              border: '1px solid #d9d9d9',
              borderRadius: '4px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15, 0.15)'
            }}
            options={[
              { value: "gpt-4o-mini-2024-07-18", label: "GPT-4O Mini" },
              { value: "gpt-4o", label: "GPT-4O" },
              { value: "gemini-1.5-flash", label: "Gemini 1.5 Flash" },
              { value: "gemini-2.0-flash", label: "Gemini 2.0 Flash" },
            ]}
          />
        </div>
      </Modal>

      {/* Upload Resume Modal */}
      <Modal
        title="Upload Resume"
        open={uploadPopupOpen}
        onCancel={() => {
          setUploadPopupOpen(false);
          setSelectedSource('');
        }}
        footer={null}
        width={400}
      >
        <div style={{ padding: '20px' }}>
          <Typography style={{ marginBottom: '20px' }}>Select Resume Source:</Typography>
          <AntSelect
            style={{ width: '100%', marginBottom: '20px' , boxShadow: '0 2px 8px rgba(0, 0.15, 0.15, 0.15)', borderRadius: '6px', height: '50px' }}
            placeholder="Select source"
            value={selectedSource}
            onChange={(value) => setSelectedSource(value)}
            options={RESUME_SOURCES}
          />
          
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
            <Button
              onClick={() => {
                const fileInput = document.createElement("input");
                fileInput.type = "file";
                fileInput.accept = "application/pdf";
                fileInput.multiple = true;
                fileInput.onchange = async (e) => {
                  const files = Array.from(e.target.files);
                  if (files.length > 0 && selectedSource) {
                    await handleResumeUpload(files, selectedSource);
                  } else if (!selectedSource) {
                    toasty("Please select a resume source", "error");
                  }
                };
                fileInput.click();
              }}
              variant="contained"
              disabled={!selectedSource}
              style={{
                backgroundColor: "var(--Blue-600, rgba(37, 99, 235, 1))",
                color: "white",
              }}
            >
              Upload from Device
            </Button>
            
            <Button
              onClick={() => setUploadPopupOpen(false)}
              variant="outlined"
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Details;
